import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';

import Home from './routers/Home';
import Error404 from './routers/error/Error404';
import Salas from './routers/sala/Salas';
import Sala from './routers/sala/Sala';
import Pessoa from './routers/pessoa/Pessoa';
import Pessoas from './routers/pessoa/Pessoas';
import AlterarPessoa from './routers/pessoa/AlterarPessoa';
// import NiveisAcesso from './routers/niveisacesso/NiveisAcesso';
// import NivelAcesso from './routers/niveisacesso/NivelAcesso';
import Login from './routers/login/Login';
// Eventos.
import Evento from './routers/evento/Evento';
import Eventos from './routers/evento/Eventos';
// import EventosFinalizados from './routers/evento/EventosFinalizados';
// Subeventos.
import Subevento from './routers/subevento/Subevento';
// Páginas.
import Paginas from './routers/pagina/Paginas';
import Pagina from './routers/pagina/Pagina';
// Critérios.
// import Criterios from './routers/criterio/Criterios';
// import Criterio from './routers/criterio/Criterio';
// Áreas.
import Area from './routers/area/Area';
import Projetos from './routers/projeto/Projetos';
import ProjetoInfo from './routers/projeto/ProjetoInfo';
import AcompanharAvaliador from './routers/projeto/AcompanharAvaliador';
import AvaliarProjeto from './routers/projeto/AvaliarProjeto';
import ProjetosAvaliador from './routers/projeto/ProjetosAvaliador';
import ProjetosAutor from './routers/projeto/ProjetosAutor';
import NotasDiscrepantes from './routers/projeto/NotasDiscrepantes';
import NotasApresentacao from './routers/projeto/NotasApresentacao';
// import NotasResumo from './routers/projeto/NotasResumo';
// import Assinatura from './routers/assinatura/Assinatura';
// import Categoria from './routers/categoria/Categoria';
import TipoApresentacao from './routers/tipoapresentacao/TipoApresentacao';
// Inscrição
import Inscricao from './routers/inscricao/Inscricao';
import ImprimirCertificado from './routers/pessoa/ImprimirCertificado';
import ImprimirCertificadoOuvinte from './routers/pessoa/ImprimirCertificadoOuvinte';
import InscricaoStepFormasDePagamento from './routers/inscricao/InscricaoStepFormasDePagamento';
import InscricaoStepFinalizar from './routers/inscricao/InscricaoStepFinalizar';
import InscricaoDetalhesOuvinte from './routers/inscricao/InscricaoDetalhesOuvinte';
import CalcularMedias from './routers/projeto/CalcularMedias';
import InscricaoOuvinte from './routers/inscricao/InscricaoOuvinte';
import InscricaoOuvinteFormasDePagamento from './routers/inscricao/InscricaoOuvinteFormasDePagamento';
import ProjetosAprovados from './routers/projeto/ProjetosAprovados';
// import SqlAdmin from './routers/evento/SqlAdmin';
import OrganizarApresentacao from './routers/projeto/OrganizarApresentacao';
import Ouvintes from './routers/ouvinte/Ouvintes';
import ConfirmarApresentacao from './routers/projeto/ConfirmarApresentacao';
import ImprimirCertificadoComissao from './routers/pessoa/ImprimirCertificadoComissao';

// PDFs.
// import PDFTest from './routers/relatorio/PDFTest';

const AppRouter = () => (
    <Router>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/error/404" component={Error404} />
            <Route exact path="/paginas" component={Paginas} />
            <Route exact path="/paginas/add/:codigo?" component={Pagina} />
            <Route exact path="/inscricao" component={Inscricao} />
            <Route exact path="/inscricao/resumo/:codigoProjeto/:autor?" component={InscricaoStepFinalizar} />
            <Route exact path="/inscricao-ouvinte/resumo/:codigoOuvinte" component={InscricaoDetalhesOuvinte} />
            <Route exact path="/inscricao/pagamento/:codigoProjeto" component={InscricaoStepFormasDePagamento} />
            <Route exact path="/organizar-apresentacao" component={OrganizarApresentacao} />
            <Route exact path="/eventos/add/:codigo?" component={Evento} />
            <Route exact path="/eventos/:evento?/:subevento?/:opcao?" component={Eventos} />
            <Route exact path="/subeventos/add/:evento?/:subevento?" component={Subevento} />
            <Route exact path="/salas" component={Salas} />
            <Route exact path="/salas/add/:codigo?" component={Sala} />
            <Route exact path="/pessoas" component={Pessoas} />
            <Route exact path="/pessoas/add/:codigo?" component={Pessoa} />
            <Route exact path="/alterar-pessoa" component={AlterarPessoa} />
            <Route exact path="/areas/add/:subevento/:codigo?" component={Area} />

            {/*
            <Route exact path="/sql-admin" component={SqlAdmin} />
            <Route exact path="/error/403" component={Error403} />
            <Route exact path="/error/500" component={Error500} />
            <Route exact path="/download-pdf" component={PDFTest} />

            <Route exact path="/eventos-finalizados" component={EventosFinalizados} />
            <Route exact path="/niveis-acesso" component={NiveisAcesso} />
            <Route exact path="/niveis-acesso/add/:codigo?" component={NivelAcesso} />
            <Route exact path="/criterios" component={Criterios} />
            <Route exact path="/criterios/add/:subevento/:codigo?" component={Criterio} />
            <Route exact path="/assinaturas/add/:subevento/:codigo?" component={Assinatura} />
            <Route exact path="/categorias/add/:subevento/:codigo?" component={Categoria} />
            */}


            <Route exact path="/tiposapresentacao/add/:subevento/:codigo?" component={TipoApresentacao} />
            <Route exact path="/projetos" component={Projetos} />
            <Route exact path="/projeto-info/:projeto?" component={ProjetoInfo} />
            <Route exact path="/notas-discrepantes" component={NotasDiscrepantes} />
            <Route exact path="/notas-apresentacao" component={NotasApresentacao} />
            {/* <Route exact path="/notas-resumo" component={NotasResumo} /> */}
            <Route exact path="/acompanhar-avaliador/" component={AcompanharAvaliador} />
            <Route exact path="/avaliar-projeto/:projeto?" component={AvaliarProjeto} />
            <Route exact path="/projetos-avaliador/:avaliador?" component={ProjetosAvaliador} />
            <Route exact path="/projetos-autor" component={ProjetosAutor} />
            <Route exact path="/calcular-medias" component={CalcularMedias} />
            <Route exact path="/inscricao-ouvinte/:evento?" component={InscricaoOuvinte} />
            <Route exact path="/ouvinte/pagamento/:codigoOuvinte" component={InscricaoOuvinteFormasDePagamento} />
            <Route exact path="/projetos-aprovados/:evento" component={ProjetosAprovados} />
            <Route exact path="/ouvintes" component={Ouvintes} />
            <Route exact path="/certificados/:evento?" component={ImprimirCertificado} />
            <Route exact path="/certificados-ouvinte" component={ImprimirCertificadoOuvinte} />
            <Route exact path="/certificados-comissao" component={ImprimirCertificadoComissao} />
            <Route exact path="/confirmar-apresentacao" component={ConfirmarApresentacao} />

            <Redirect to="/error/404" />
        </Switch>
    </Router>
);

export default AppRouter;
